












































import { defineComponent, PropType, Ref, computed } from '@vue/composition-api';
import Videos from '@/data/Videos';
import VideoPreview from '@/components/VideoPreview.vue';
import VideoListLayout from '@/data/layout/VideoListLayout';

export default defineComponent({
  name: 'VideoList',
  components: {
    VideoPreview    
  },
  props: {
    allVideos: {
      type: Object as PropType<Videos>,
      required: true
    },
    offset: {
      type: Number,
      default: 0
    },
    limit: {
      type: Number,
      default: 1000000
    },
    rowCount: {
      type: Object as PropType<Ref<number|undefined>>,
      default: undefined
    },
    locale: {
      type: String,
      default: undefined
    },
    videoListLayout: {
      type: Object as PropType<VideoListLayout>,
      required: true
    }
  },
  emits: {
    'video-selected': (/*video: Video*/) => true
  },
  setup(props) {

    const videos = computed(() => {
      let offset = props.offset;
      if(props.offset !== 0 && props.allVideos.videos.length <= props.limit && props.offset + props.limit > props.allVideos.videos.length) {
        offset = props.allVideos.videos.length - props.limit;
      }

      return props.allVideos.videos.slice(offset, offset + props.limit);
    });

    return  {
      videos
    };
  }
});
